<template>
	<div class="pa-block">
		<h3 class="selector-title">Validation et paiement</h3>
		<div class="pa-block__inner">
			<div class="pa-block__flex">
				<img
					src="/wp-content/themes/id/images/classified/illustrations/illustration-validation-paiement.png"
					width="56"
					height="69"
					alt=""
				/>
				<div>
					<fieldset>
						<legend>
							Vérifiez les informations saisies et validez-les pour finaliser la
							transaction sur notre boutique en ligne.
						</legend>
					</fieldset>
					<p>
						<span
							v-if="
								0 <
								getPrice(classified, {
									with_options: true,
									include_diff_abcdent:
										classified.mode !== 'print_web' && !isCurrentCategoryFree,
								})
							"
						>
							Dès réception de votre paiement (carte bancaire ou chèque), votre
							annonce sera mise en ligne sur le site
							www.information-dentaire.fr.
						</span>
						<span v-else>
							Pour valider cette annonce gratuite, vous devez finaliser le
							paiement à 0,00 €. Dès validation de votre commande, l'annonce
							sera mise en ligne sur le site www.information-dentaire.fr
						</span>
						<span
							v-if="
								classified.option_diff_abcdent_pro == 1 ||
								classified.option_diff_abcdent == 1
							"
						>
							Elle sera également publiée sur le site
							<a href="https://abcdent.pro">Abcdent.pro</a> dans un délai de 10
							minutes.
						</span>
						<span v-if="classified.mode == 'print_web'">
							Elle sera mise en page pour insertion dans la revue L'Information
							Dentaire dès la prochaine parution (insertion dans le numéro du
							mercredi pour tout règlement reçu jusqu'au jeudi précédent).
						</span>
					</p>
				</div>
			</div>
		</div>
		<!-- .pa-block__inner -->
	</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
	name: "classified-notice",
	computed: {
		...mapState(["classified"]),
		...mapGetters(["isCurrentCategoryFree"]),
	},
};
</script>
